import React, { useMemo, useState, useEffect } from "react";
import Parse from "parse";
import moment from "moment-with-locales-es6";
import SimpleSlider from "./SimpleSlider";
import { Box, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import "../../StylesPages/dashboard.css";

export const EventsPerMonths = () => {
  const navigate = useNavigate();
  const [eventsSlider, setEventsSlider] = useState([]);

  moment.locale("fr");
  async function fetchEvent() {
    const Event = Parse.Object.extend("Annonce");
    const query = new Parse.Query(Event);
    query.equalTo("type", "event");
    const currentUser = Parse.User.current();
    query.equalTo("userId", currentUser);
    query.greaterThanOrEqualTo(
      "dateDebut",
      moment().subtract(300, "days").startOf("month").toDate()
    );
    query.ascending("dateDebut");

    const event = await query.find().catch((error) => {
      alert(
        "Failed to update user informations, with error code: " + error.message
      );
      Parse.User.logOut();
      navigate("/");
    });

    const tempData = [];
    if (event !== undefined) {
      for (let i = 0; i < event.length; i++) {
        tempData.push({
          id: event[i].id,
          title: event[i].get("titre"),
          date: event[i].get("dateDebut").toString(),
          date2: moment(event[i].get("dateDebut"))
            .locale("fr")
            .format("LLLL")
            .toString(),
          inscrits: event[i].get("nbInscrit"),
          nbInscritMax: event[i].get("nbInscritMax"),
          adresse: event[i].get("adresse"),
          logo: event[i].get("logoEnterprise"),
        });
      }

      var eventsParMois = new Map();
      tempData.map((e) => {
        var month = moment(e.date);
        var monthNumber = month.month();
        var eventsOfMonthTable = eventsParMois.get(monthNumber);
        if (!eventsOfMonthTable) {
          eventsOfMonthTable = [[]];
        }
        eventsOfMonthTable[0].push(e);
        eventsParMois.set(monthNumber, eventsOfMonthTable);
        //month.format("ddd MMM DD YYYY");
      });
      setEventsSlider(eventsParMois);
    }
    return event;
  }

  useEffect(() => {
    fetchEvent();
  }, []);

  return (
    <Box
      className="events-per-months-container"
      w="90%"
      borderRadius={"20px"}
      margin="10px"
    >
      {eventsSlider.length ? <SimpleSlider eventsSlider={eventsSlider}></SimpleSlider> : <Text p={4} fontFamily={"Sofia Pro"} fontSize={"24px"} mt={8}>Pas d'évènements à venir</Text>}
    </Box>
  );
};




export default EventsPerMonths;
